import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsInfinitiComponent } from './simple-icons-infiniti.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsInfinitiComponent ],
    exports:      [ SimpleIconsInfinitiComponent ],
    bootstrap:    []
})
export class SimpleIconsInfinitiModule {}
